import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 17l-6 4v-14a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v8","key":"svg-0"}],["path",{"d":"M16 19h6","key":"svg-1"}]]

/**
 * IconBookmarkMinus
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYm9va21hcmstbWludXMiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTEyIDE3bC02IDR2LTE0YTQgNCAwIDAgMSA0IC00aDRhNCA0IDAgMCAxIDQgNHY4IiAvPgogIDxwYXRoIGQ9Ik0xNiAxOWg2IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/bookmark-minus
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBookmarkMinus = createReactComponent('outline', 'bookmark-minus', 'BookmarkMinus', __iconNode);

export default IconBookmarkMinus;